// 导入组件
import selectProject from './src/select-project.vue'

// 为组件提供 install 安装方法，供按需引入
selectProject.install = function (Vue) {
  Vue.component(selectProject.name, selectProject)
}

// 默认导出组件
export default selectProject
